import { render } from "./clear.vue?vue&type=template&id=3842f7d6"
import script from "./clear.vue?vue&type=script&lang=js"
export * from "./clear.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__